import { ItemSheetOriginal } from "@/types/itemsheet";
import { Skeleton } from "@/components/ui/skeleton";
import { useProjectEstimate } from "../hooks/useProjectEstimate";
import { ProjectEstimateHeader } from "./ProjectEstimateHeader";
import { EstimateTabsView } from "./ProjectEstimateTabsView";

type Props = {
  selectedOriginal: ItemSheetOriginal;
};

export default function ProjectEstimate({ selectedOriginal }: Props) {
  const {
    tab,
    setTab,
    budgetAmount,
    basisAmount,
    latests,
    isLoading,
    latestsSheetData,
    sumPurchaseAmount,
    sumSalesAmount,
  } = useProjectEstimate(selectedOriginal);

  if (isLoading) {
    return <Skeleton className="w-full h-96 bg-white" />;
  }

  return (
    <>
      <ProjectEstimateHeader
        budgetAmount={budgetAmount}
        basisAmount={basisAmount}
        sumPurchaseAmount={sumPurchaseAmount}
        sumSalesAmount={sumSalesAmount}
      />
      <EstimateTabsView
        tab={tab}
        setTab={setTab}
        latests={latests}
        latestsSheetData={latestsSheetData}
        selectedOriginal={selectedOriginal}
      />
    </>
  );
}
